<!-- TEMPLATE CONTRACT: Ui Stat Card Component owns the visible Angular template structure for src/app/shared/ui/ui-stat-card/ui-stat-card.component.html. -->
<section class="ui-stat-card">
  <p class="ui-stat-card__label">{{ label() | uiLabelTranslate }}</p>
  <p class="ui-stat-card__value">{{ value() }}</p>
  <!-- Conditional branch documents the visible UI state for this condition. -->
  @if (delta()) {
    <p class="ui-stat-card__delta">{{ delta() }}</p>
  }
</section>
